import React from 'react';
import Icon from '../../../components/AppIcon';

const DocumentTemplateSelector = ({ selectedTemplate, onTemplateSelect, templates }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
          <Icon name="FileText" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="text-base md:text-lg font-semibold text-foreground">Documentation Templates</h3>
          <p className="text-xs md:text-sm text-muted-foreground">Select a template to begin</p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {templates?.map((template) => (
          <button
            key={template?.id}
            onClick={() => onTemplateSelect(template)}
            className={`flex flex-col items-start p-4 rounded-lg border-2 transition-all duration-250 ease-out ${
              selectedTemplate?.id === template?.id
                ? 'border-primary bg-primary/5' :'border-border bg-card hover:border-primary/50 hover:bg-muted'
            }`}
          >
            <div className="flex items-center gap-2 mb-2 w-full">
              <Icon name={template?.icon} size={18} color={selectedTemplate?.id === template?.id ? 'var(--color-primary)' : 'var(--color-muted-foreground)'} />
              <span className="text-sm font-semibold text-foreground">{template?.name}</span>
            </div>
            <p className="text-xs text-muted-foreground text-left line-clamp-2">{template?.description}</p>
            <div className="flex items-center gap-2 mt-3">
              <span className="text-xs px-2 py-1 bg-muted rounded text-muted-foreground">{template?.specialty}</span>
              <span className="text-xs text-muted-foreground">{template?.estimatedTime}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default DocumentTemplateSelector;